import { HelpCircle } from 'lucide-react';
import { cn } from '@/lib/utils';

const CALENDLY_URL = 'https://calendly.com/mccollins/keepmore-intro';

interface NeedHelpLinkProps {
  className?: string;
  showText?: boolean;
  label?: string;
}

export function NeedHelpLink({
  className,
  showText = true,
  label = 'Need Help?',
}: NeedHelpLinkProps) {
  return (
    <a
      href={CALENDLY_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'flex items-center justify-center gap-2 bg-primary text-primary-foreground hover:bg-primary/90 p-2.5 rounded-md cursor-pointer transition-all font-medium shadow-sm',
        className
      )}
    >
      <HelpCircle className="h-4 w-4" />
      {showText && <span>{label}</span>}
    </a>
  );
}
